export default class ThresholdsLevel {
  public critical: number
  public warning: number
}
